import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Flex, FormField, TextInput } from '@percent/lemonade';
import { useProgress } from '@percent/hosted-validation-form/hooks';
import { Card } from '@percent/hosted-validation-form/ui';
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData';
import { HostedFormStep } from '../../HostedForm.types';

type FormFieldValues = {
  firstName: string;
  lastName: string;
};

export const ContactDetails = () => {
  const { handleNext, handleBack } = useValidationStepData();
  const {
    formState: { errors, dirtyFields },
    register,
    watch,
  } = useFormContext<FormFieldValues>();
  const firstName = watch('firstName');
  const lastName = watch('lastName');
  const { t } = useTranslation();
  const { progress } = useProgress();

  const handleNavigateNext = () => handleNext(HostedFormStep.EMAIL);

  return (
    <Card
      onBack={handleBack}
      title={t('hostedValidation.title.provideContactDetails')}
      description={t('hostedValidation.title.willUseThisInfo')}
      progress={progress}
      onNext={handleNavigateNext}
      nextButtonLabel={t('hostedValidation.button.next')}
      nextButtonDisabled={
        !!errors['firstName'] ||
        !!errors['lastName'] ||
        !(dirtyFields['firstName'] && dirtyFields['lastName']) ||
        !firstName?.trim() ||
        !lastName?.trim()
      }
    >
      <Flex direction="column" gap={16} w="100%">
        <FormField
          label={t('hostedValidation.label.firstName')}
          status={errors.firstName?.message ? 'danger' : 'default'}
          statusMessage={errors.firstName?.message}
        >
          <TextInput {...register('firstName')} placeholder={t('hostedValidation.placeholder.firstName')} />
        </FormField>
        <FormField
          label={t('hostedValidation.label.lastName')}
          status={errors.lastName?.message ? 'danger' : 'default'}
          statusMessage={errors.lastName?.message}
        >
          <TextInput {...register('lastName')} placeholder={t('hostedValidation.placeholder.lastName')} />
        </FormField>
      </Flex>
    </Card>
  );
};
